import { RootState } from '../../main/store/main.store.ts';
import { createMemoizedSelector } from '../../main/utils/selector/create-memoized-selector.ts';

export const selectCurrentStepType = createMemoizedSelector(
  (state: RootState) => state.lesson.currentStep,
  (step) => step?.stepType
);
